import React from 'react';
import seal from '../../assets/state-seal-transparent.png';

import './Banner.scss';

const Banner = () => {
  return (
    <header className='the-vista'>
      <div className='banner-container'>
        <div className='row county-row'>
          <div className='col-sm-2 header-logo'>
            <a className='logo navbar-btn opacity' href='/' title='Home'>
              <img className='logo-img' src={seal} alt='Great Seal of the State of Nebraska Logo' />
            </a>
          </div>
          <div className='col-sm-6 header-logo-text'>
            <a className='logo navbar-btn opacity' href='/' title='Home'>
              <span>Nebraska Secretary of State</span>
              <br/>
              <span className='logo-name'>Robert B. Evnen</span>
            </a>
          </div>
          <div className='col-sm-4'>
            <div></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Banner;
